export const API_BASE = process.env.REACT_APP_API_BASE;   // e.g. http://localhost:5000/api
export const API_HOST = process.env.REACT_APP_API_HOST;   // e.g. http://localhost:5000
